import {
  buildSelectedCountLabel,
  parseDelimitedQueryValues,
  selectedUsersRecipientRules,
} from "./EmailAssistantManualQueryContextHelpers";
import type { EmailAssistantQueryContext } from "./EmailAssistantQueryContextTypes";

export const buildUsersDashboardEmailAssistantQueryContext = (
  searchParams: URLSearchParams,
): EmailAssistantQueryContext | null => {
  const userIds = parseDelimitedQueryValues(
    searchParams.get("eaSelectedUserIds"),
  );
  const organisationIds = parseDelimitedQueryValues(
    searchParams.get("eaOrganisationIds"),
  );
  if (userIds.length === 0) {
    return null;
  }

  return {
    contextSections: [
      {
        title: "Selected users",
        subtitle: buildSelectedCountLabel(
          userIds,
          searchParams.get("eaSelectedCount"),
          "user",
          "users",
        ),
        emptyText: "No selected users were provided.",
        items: [
          {
            label: "Recipient source",
            detail:
              "Selected CRM user identities. Email & Comms resolves linked people and checks each recipient before a job can run.",
          },
          {
            label: "Owner boundary",
            detail:
              "CRM keeps identity context. Email & Comms owns recipient preview, preferences, Activity, audit, and job creation.",
          },
          {
            label: "Recent communications",
            detail:
              "Dashboard bulk handoffs show open alerts only. Open Activity if recent history could change the send decision.",
          },
          {
            label: "Upcoming sends",
            detail:
              "Dashboard bulk handoffs do not show full upcoming send logs for every selected recipient.",
          },
        ],
      },
    ],
    manualJobContext: {
      organisationIds,
      partnerIds: [],
      personIds: [],
      recipientRule: "selected_users",
      sourceKind: "users_dashboard",
      userIds,
    },
    recipients: userIds.map((_, index) => ({
      name: `Selected user ${index + 1}`,
      email: "",
      sourceLabel: "Users dashboard",
    })),
    recipientRuleOptions: selectedUsersRecipientRules,
    recipientRuleValue: "selected_users",
    sourceContext: {
      sourceName: "Users dashboard",
      sourceType: "CRM",
      contextLabel:
        "Opened from selected CRM users. Email & Comms resolves the safe recipient list and blocks customer delivery unless every job gate passes.",
    },
  };
};
